export default "__VITE_ASSET__bvZg3V5M__"